import React, { PureComponent } from 'react'
import { func } from 'prop-types'
import Button from '@active/react-ui/Button'
import ButtonGroup from '@active/react-ui/ButtonGroup'
import { NewECheckEUDDForm } from '../../../payments/components/ECheckEUDD'
import PaymentAlias from '../../../payments/components/common/PaymentAlias'
import I18nMessage from '../../../common/I18nMessage'
import { reduceFalseProp } from '../../../../shared/utils/commonUtils'
import '../wallet.components.scss'
import './NewECheckEUDD.scss'

class NewECheckEUDD extends PureComponent {
  static propTypes = {
    getPublicKey: func.isRequired,
    addEcheck: func.isRequired,
    addEUDD: func.isRequired,
    setErrorMsg: func.isRequired,
    handleBackView: func.isRequired,
    updatePaymentInfoList: func.isRequired,
  }

  constructor(props) {
    super(props)
    this.state = {
      exponent: '',
      modulus: '',
      displayName: '',
    }
  }

  componentDidMount() {
    this.initData()
  }

  getPaymentAliasCallBack = value => {
    this.setState({
      displayName: value,
    })
  }

  getNewECheckEUDDFormCallback = ({
    address, paymentType, ...rest
  }) => {
    const {
      addEcheck, addEUDD, setErrorMsg, updatePaymentInfoList,
    } = this.props
    const { displayName } = this.state
    const params = {
      postResource: 'wallet',
      displayName: displayName || null,
      ...rest,
      address: reduceFalseProp({
        ...address,
        countryCode: address && address.country ? address.country : null,
      }),
    }
    const apiCall = paymentType === 'ECHECK' ? addEcheck : addEUDD
    apiCall({
      headers: {
        Accept: 'application/json',
        'Content-type': 'application/json',
      },
      params,
      resolve: res => {
        if (res.status === 'FAILURE') {
          setErrorMsg(res.message, res.errorCode)
        } else {
          updatePaymentInfoList()
          setErrorMsg(null, null, true)
        }
      },
      reject: ({ message, errorCode }) => {
        setErrorMsg(message, errorCode)
      },
    })
  }

  initData = () => {
    const { getPublicKey, setErrorMsg } = this.props
    getPublicKey({
      headers: {
        Accept: 'application/json',
        'Content-type': 'application/json',
      },
      resolve: ({
        exponent, modulus, message, status, errorCode,
      }) => {
        if (status === 'FAILURE' && message) {
          setErrorMsg(message, errorCode)
        } else {
          this.setState({
            exponent,
            modulus,
          })
          setErrorMsg(null, null, true)
        }
      },
      reject: ({ message, errorCode }) => {
        setErrorMsg(message, errorCode)
      },
    })
  }

  handleClick = () => {
    this.newECheckEUDDForm()
  }

  handleCancel = () => {
    const { handleBackView } = this.props
    handleBackView()
  }

  render() {
    const { exponent, modulus } = this.state
    return (
      <div className="passport__wallet__new-echeckeudd passport__wallet__detail-component passport__wallet__components">
        <h1 className="passport__wallet__new-echeckeudd__title passport__wallet__component-title">
          <I18nMessage id="passport.wallet.newECheckEUDD.title" />
        </h1>
        {
          modulus && exponent
          && (
            <NewECheckEUDDForm
              exponent={exponent}
              modulus={modulus}
              submitTrigger={submitFunc => {
                this.newECheckEUDDForm = submitFunc
              }}
              getNewECheckEUDDFormCallback={this.getNewECheckEUDDFormCallback}
            />
          )
        }
        <PaymentAlias getPaymentAliasCallBack={this.getPaymentAliasCallBack} />
        <ButtonGroup horizontal className="grid passport__wallet__btn">
          <Button type="primary" onClick={this.handleClick}>
            <I18nMessage id="passport.wallet.create.add" />
          </Button>
          <Button type="secondary" onClick={this.handleCancel}>
            <I18nMessage id="passport.common.btn.cancel" />
          </Button>
        </ButtonGroup>
      </div>
    )
  }
}

export default NewECheckEUDD
